// Figuren-Outfits für Kapitel 3 (Palettenfarben aus art/palette.ts).
import { P } from '../art/palette.ts';
import type { Outfit } from './character.ts';

export const OUTFITS_CH3: Record<string, Outfit> = {
  // Bäckerin Hanne Hansen: weiße Schürzenjacke, Bäckermütze, rotes Halstuch
  baeckerin: { coat: P.white, pants: P.wood1, hair: P.amber1, skin: P.skin2, boots: P.wood0, hat: P.paper, scarf: P.red2 },
  // Pastorin Wiebke Harms: schwarzer Talar mit weißem Beffchen
  pastorin: { coat: P.ink, pants: P.ink, hair: P.wood2, skin: P.skin2, boots: P.ink, scarf: P.white },
  // Uhrmacher Tönnies Brodersen: braune Weste, weißer Bart
  uhrmacher: { coat: P.wood2, pants: P.iron1, hair: P.white, skin: P.skin1, boots: P.ink, beard: P.white, scarf: P.green1 },
  // Bibliothekarin Edda Lüders: grüne Strickjacke, graues Haar
  bibliothekarin: { coat: P.green1, pants: P.night1, hair: P.iron2, skin: P.skin2, boots: P.wood0, scarf: P.amber1 },
  // Tilda Brodersen (17), Enkelin des Uhrmachers
  tilda: { coat: P.sea2, pants: P.night2, hair: P.wood3, skin: P.skin0, boots: P.red1, scarf: P.amber2 },
  // Bürgermeister Hollmann: dunkler Anzug, Amtskette
  buergermeister: { coat: P.night1, pants: P.night1, hair: P.iron2, skin: P.skin2, boots: P.ink, beard: P.iron2, scarf: P.brass2 },
  // Frau Wiechmann, Turnierleitung im Rathaus
  wiechmann: { coat: P.red1, pants: P.ink, hair: P.plaster2, skin: P.skin2, boots: P.ink, scarf: P.paper },
};
